import type { Path } from '$app/types';
import { viewHref } from '#lib/navigation.js';

// Trail for the persistent Programs header; each screen publishes its crumbs and the section layout renders them beside "Back to map".
type Crumb = { label: string; href?: string };
// Previous/next siblings of the current screen (e.g. curves in a project); a step without an href is the end.
type Pager = { label: string; prev: Crumb; next: Crumb };

let items = $state<Crumb[]>([]);
let pager = $state<Pager | undefined>();

export const programsBreadcrumbs = {
	get items() {
		return items;
	},
	get pager() {
		return pager;
	},
	// Each screen publishes its whole trail, so one without a pager clears the last one's.
	set(next: Crumb[], nextPager?: Pager) {
		items = next;
		pager = nextPager;
	}
};

// Versioned href under the Programs section; each segment is URI-encoded.
export function programsPath(...segments: string[]): string {
	return viewHref(['safecurves/programs', ...segments.map(encodeURIComponent)].join('/') as Path);
}
